import type { AnalysisApiResponse, ConfidenceConfig } from "./types";

export const confidenceConfig: Record<string, ConfidenceConfig> = {
  HIGH: {
    color: "#059669",
    bg: "#ecfdf5",
    darkBg: "rgba(16,185,129,0.08)",
    borderColor: "#a7f3d0",
    darkBorderColor: "rgba(16,185,129,0.2)",
    label: "High Confidence",
    percent: 90,
  },
  MEDIUM: {
    color: "#d97706",
    bg: "#fffbeb",
    darkBg: "rgba(217,119,6,0.08)",
    borderColor: "#fde68a",
    darkBorderColor: "rgba(217,119,6,0.2)",
    label: "Medium Confidence",
    percent: 55,
  },
  LOW: {
    color: "#dc2626",
    bg: "#fef2f2",
    darkBg: "rgba(220,38,38,0.08)",
    borderColor: "#fecaca",
    darkBorderColor: "rgba(220,38,38,0.2)",
    label: "Low Confidence",
    percent: 25,
  },
};

export const prStatusConfig: Record<
  string,
  { color: string; bg: string; darkBg: string; label: string }
> = {
  open: {
    color: "#059669",
    bg: "#ecfdf5",
    darkBg: "rgba(16,185,129,0.12)",
    label: "Open",
  },
  merged: {
    color: "#7c3aed",
    bg: "#ede9fe",
    darkBg: "rgba(124,58,237,0.12)",
    label: "Merged",
  },
  closed: {
    color: "#dc2626",
    bg: "#fef2f2",
    darkBg: "rgba(220,38,38,0.12)",
    label: "Closed",
  },
  draft: {
    color: "#6b7280",
    bg: "#f3f4f6",
    darkBg: "rgba(107,114,128,0.12)",
    label: "Draft",
  },
};

export const statusConfig: Record<
  string,
  { color: string; bg: string; darkBg: string; label: string; icon: string }
> = {
  pending: {
    color: "#6b7280",
    bg: "#f3f4f6",
    darkBg: "rgba(107,114,128,0.12)",
    label: "Pending",
    icon: "⏳",
  },
  in_progress: {
    color: "#3b82f6",
    bg: "#eff6ff",
    darkBg: "rgba(59,130,246,0.12)",
    label: "Analyzing...",
    icon: "⚙",
  },
  completed: {
    color: "#059669",
    bg: "#ecfdf5",
    darkBg: "rgba(16,185,129,0.12)",
    label: "Completed",
    icon: "✓",
  },
  failed: {
    color: "#dc2626",
    bg: "#fef2f2",
    darkBg: "rgba(220,38,38,0.12)",
    label: "Failed",
    icon: "✕",
  },
};
